var map = {
  "./cs.json": [
    "jQ",
    [
      "pk"
    ]
  ],
  "./en.json": [
    "kf",
    [
      "2vs"
    ]
  ],
  "./pl.json": [
    "m5",
    [
      "w6"
    ]
  ],
  "./ru.json": [
    "Btq",
    [
      "r"
    ]
  ],
  "./tr.json": [
    "aPQ",
    [
      "05"
    ]
  ],
  "./ja.json": [
    "e7B",
    [
      "oc"
    ]
  ],
  "./zh.json": [
    "ro",
    [
      "lv"
    ]
  ],
  "./pt-br.json": [
    "qm",
    [
      "0k"
    ]
  ],
  "./de.json": [
    "U5",
    [
      "qu0"
    ]
  ],
  "./es.json": [
    "Sb",
    [
      "8y"
    ]
  ],
  "./fr.json": [
    "w4",
    [
      "ec"
    ]
  ],
  "./it.json": [
    "ceW",
    [
      "6v"
    ]
  ],
  "./ko.json": [
    "uJ",
    [
      "o2"
    ]
  ],
  "./pt.json": [
    "HkW",
    [
      "hu"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "qZ";
module.exports = __rspack_async_context;
